import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ABTestBranchActionExplainer({
  action,
  flowObjectTypeId
}) {
  const connection = action.getConnection();
  const numOfBranches = connection.connections.length;
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.ab-test-branch.explainer_cob",
    objectTypeId: flowObjectTypeId,
    options: {
      numOfBranches
    }
  });
}